import Link from 'gatsby-link'
import * as React from 'react'
import Button from '../button/button'
import Logo from '../logo/logo'
import Navigation from '../navigation/navigation'
import SingInUrlProvider from '../signin/SignInUrlProvider'
import './footer.scss'

class Footer extends React.Component<{}, any> {
  public handleClickSlack = () => {
    analytics.track('Slack Account OAuth Initiated', {
      category: 'Visitor',
      label: 'Sign In With Slack [footer]',
    })
  }

  public render() {
    return (
      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="footer-navigation">
                <div className="footer-navigation__wrapper">
                  <div className="footer-navigation__left">
                    <Logo />
                    <Navigation
                      extraClasses="navigation--footer"
                      showButton={false}
                    />
                  </div>
                  <div className="footer-navigation__right">
                    {/* <SingInUrlProvider>
                      <Button
                        extraClasses="btn--slack btn--small"
                        content=""
                        onClick={this.handleClickSlack}
                      />
                    </SingInUrlProvider> */}
                  </div>
                </div>
              </div>
              <div className="footer__separator" />
              <div className="footer__wrapper">
                <ul className="footer-links__list">
                  <li className="footer-links__item">
                    <Link className="footer__text" to="/terms-of-use">
                      Terms of Use
                    </Link>
                  </li>
                  <li className="footer-links__item">
                    <Link className="footer__text" to="/privacy-policy">
                      Privacy Policy
                    </Link>
                  </li>
                  <li className="footer-links__item">
                    <Link className="footer__text" to="/gdpr">
                      GDPR Compliance
                    </Link>
                  </li>
                  <li className="footer-links__item">
                    <Link className="footer__text" to="/cookies">
                      Cookies
                    </Link>
                  </li>
                </ul>
                <div className="footer__logo">
                  <Logo />
                </div>
                <div className="footer__text footer__text--copyright">
                  © 2019 Bizy, LLC.
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer/footer.tsx